"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expIsConst = void 0;
/**
 * Returns true if the given polynomial is the zero polynomial
 * @param a a polynomial
 */
function expIsConst(a) {
    return a.length <= 1;
}
exports.expIsConst = expIsConst;
//# sourceMappingURL=is-const.js.map